import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RedirectionComponent } from './redirection/redirection.component';
import { DimeloRoutingModule } from './dimelo-routing.module';

@NgModule({
  declarations: [RedirectionComponent],
  imports: [
    DimeloRoutingModule,
    CommonModule
  ]
})
export class DimeloModule { }
